module.exports = __webpack_public_path__ + "img/DSC00724.5c86d96d.jpg";